import React, { Component } from 'react';

import { connect } from 'react-redux';
import VisitorPopUp from './VisitorPopUp';
import { dataUser } from "../Helpers/util";
import { SetView } from '../../Redux/action/visitorAction';

import moment from 'moment';
import mixpanel from 'mixpanel-browser';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
class VisitorTable extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      todayTime: new Date(),
      setIndex: 0,
      items: {},
      loader: false,
    };
  }
  visitorStatus = ['Details pending', 'Details uploaded', 'Details approved', 'Checked-in', 'Details rejected', 'Visit cancelled', 'Checked-out'];

  changeforward = () => {
    this.setState({
      setIndex: this.state.setIndex + 1,
      loader: true,
    });
    var itemIndex = this.state.items[this.state.setIndex + 1];
    var singleId = itemIndex.id;
    let parm = {
      visitid: singleId,
    };
    this.props.SetView(parm);
  };

  changebackformward = () => {
    this.setState({
      setIndex: this.state.setIndex - 1,
      loader: true,
    });
    var itemIndex = this.state.items[this.state.setIndex - 1];
    var singleId = itemIndex.id;
    let parm = {
      visitid: singleId,
    };
    this.props.SetView(parm);
  };

  sendId = (Id, i) => {
    const parId = {
      visitid: Id,
      setIndex: i,
    };
    this.props.SetView(parId);
  };

  componentWillReceiveProps(props) {
    if (
      props.visitorReducer.VisitorTableData &&
      props.visitorReducer.VisitorTableData?.data != 0
    ) {
      this.setState({
        items:
          props.visitorReducer.VisitorTableData &&
          props.visitorReducer.VisitorTableData?.data,
        loader: false,
      });
    }
  }

  componentDidMount() {
    this.visitorManagementMixPanel();
  }

  visitorManagementMixPanel() {
    mixpanel.track('Reports VMS Page View', {
      PageName: 'Visitor Management',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Visitor Management',
    });
  }

  render() {
   
    const visitorDataTable = this.props.visitorReducer.VisitorTableData;
    const tableData = this.props.visitorReducer.VisitorTableData;
    const loading = this.props.visitorReducer.loading;
   
   
    return (
      <>
        <div className="custome modal right fade" id="myModal3" data-backdrop="static">
          <div className="modal-dialog custome">
            <div className="modal-content custome">
              <div
                className={
                  this.state.loader != true ? 'loader disable' : 'loader'
                }
              />
              <div className="formTitle">
                Visitor Details
                <div className="nextBtnArea">
                  <span
                    className="leftIconne"
                    onClick={this.changebackformward}
                  >
                    <i className="fa fa-angle-left" aria-hidden="true" />
                  </span>
                  <span className="leftIconne" onClick={this.changeforward}>
                    <i className="fa fa-angle-right" aria-hidden="true" />
                  </span>
                </div>
                <button
                  type="button"
                  className="relateDox close"
                  data-dismiss="modal"
                >
                  x
                </button>
              </div>
              <div className="modal-body custome">
                <VisitorPopUp />
              </div>
              <div className="addmemberFooter">
                <div className="pull-right">
                  <button
                    className="btn btn-outline-dark solCancel"
                    type="button"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                  {/* <button className="btn btn-success addDetails ml10">Update</button> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tableHeaderResponse NewHeadRespData">
          <div className="fullsx">
            <div className="divFlex">
              <div
                className="tableresBox "
                data-toggle="tooltip"
                data-placement="top"
                title="Filter is applied in Visitors This Week."
              >
                <p>Visits this week </p>
                <h3>{visitorDataTable?.countweek}</h3>
              </div>
            </div>
          
            <div className="divFlex">
              <div
                className="tableresBox "
                data-toggle="tooltip"
                data-placement="top"
                title="Filter is applied in Unique Visitors This Week."
              >
                <p>Unique Visitors This Week </p>
                <h3>{visitorDataTable?.unique}</h3>
              </div>
            </div>
          </div>
        </div>

        {visitorDataTable?.data != '' ? (
          <div className="commonTable relatLoader">
            <div className={!loading ? 'mLoader loadoff' : 'mLoader'} />
            <table className="table customeTable">
              <thead>
                <tr>
                  {/* <th>Profile Picture</th> */}
                  <th>Name</th>
                  <th> Visitor Type</th>
                  <th>Phone No.</th>
                  <th>Location</th>
                  <th>Host Name</th>
                  <th>Host Email</th>
                  <th>In Time</th>
                  <th>Current Status</th>
                </tr>
              </thead>
              <tbody>
                {tableData?.data !== 0
                  ? tableData?.data &&
                  tableData?.data &&
                  tableData?.data?.map((items, i) => (
                    <tr
                      className="pulse"
                      key={i}
                      data-toggle="modal"
                      data-target="#myModal3"
                      onClick={() => this.sendId(items.id, i)}
                    >
                      {/* <td>
                                                        <div className="figure">
                                                            {
                                                                items.profile_picture != null ? (
                                                                    <img src={items.profile_picture} className="seImg" />
                                                                ) : (
                                                                    <img src="https://smartworks-production.s3-ap-southeast-1.amazonaws.com/app_profile/profile.png" className="seImg" />
                                                                )
                                                            }

                                                        </div>
                                                    </td> */}
                      <td className="dataFont">
                        {items.fname} {items.lname}
                      </td>
                      <td>
                        <p>
                          {items.visitor_type == 1
                            ? 'Walk-In'
                            : // : items.approve_by_client == 2
                            // ? 'Approved'
                            // : 'Rejected'
                            'Pre-Invite'}
                        </p>
                      </td>
                      <td>{items.phone}</td>
                      <td>{items.name}</td>
                      <td>
                        {items.hfirstname} {items.hlastname}{' '}
                      </td>
                      <td>{items.hemail}</td>
                      <td>
                        {moment(items.in_time).format('DD-MM-YYYY')}{' '}
                        {moment(items.in_time).format('hh:mm:ss')}
                      </td>
                      <td className="statusRelate">
                    
                        {items?.approve_by_client && this.visitorStatus[items.approve_by_client]}
                        <span className="viewOnly">
                          <i className="fa fa-eye" aria-hidden="true" />
                        </span>
                      </td>
                    </tr>
                  ))
                  : null}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="Nodata">
            <p style={{ color: '#e00' }}>NoData Found</p>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  visitorReducer: state.visitorReducer,
});

const mapActionsToProps = {
  SetView,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(VisitorTable);
